import { useReactiveVar } from '@apollo/client'
import React from 'react'

import { isHighContrastVar } from '../graphql/cache'
import { setIsHighContrast } from '../lib/storage'
import { useI18n } from '../../configuration/contexts/I18nContext'

export const useHighContrastToggle = () => {
  const i18n = useI18n()

  const isHighContrast = useReactiveVar(isHighContrastVar)
  const contrastTitle = isHighContrast
    ? i18n.t('contrasts.decrease')
    : i18n.t('contrasts.increase')

  const handleToggleHighContrast = React.useCallback(() => {
    const updatedContrast = !isHighContrastVar()
    setIsHighContrast(updatedContrast)
    isHighContrastVar(updatedContrast)
  }, [])

  return {
    contrastTitle,
    isHighContrast,
    handleToggleHighContrast,
  }
}
